import { z } from 'zod'
import { atomWithSessionStorage } from '../useStorage/atomsWithStorages'
import { MFRM_REST_LEAD_SAVED_KEY } from '../conventions'

export const savedAtom = atomWithSessionStorage(MFRM_REST_LEAD_SAVED_KEY, true, z.boolean())
